import { __awaiter } from "tslib";
import axios from 'axios';
class CoinCloudApiWrapper {
    constructor(config) {
        this.config = config;
    }
    setUserTags(tags) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`${CoinCloudApiWrapper.userTagsEndPoint}/user/tags`, tags, {
                headers: {
                    Authorization: (_a = this.config.auth) !== null && _a !== void 0 ? _a : '',
                },
            })).data;
        });
    }
    getUserStats() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.userStats === undefined) {
                yield this.fetchUserStats();
            }
            return this.userStats;
        });
    }
    fetchUserStats() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const result = (yield axios.get(`${CoinCloudApiWrapper.userDashboardEndPoint}/dashboard`, {
                headers: {
                    'X-Auth-Token': (_a = this.config.token) !== null && _a !== void 0 ? _a : '',
                },
            })).data;
            if (result === null || result === void 0 ? void 0 : result.success) {
                this.userStats = result === null || result === void 0 ? void 0 : result.result;
                return result === null || result === void 0 ? void 0 : result.result;
            }
            this.userStats = null;
            throw Error('Cloud Function Error');
        });
    }
    static get(config) {
        return new CoinCloudApiWrapper(config);
    }
}
CoinCloudApiWrapper.userTagsEndPoint = 'https://coin-service-users-server-zatxacztoa-uc.a.run.app';
CoinCloudApiWrapper.userDashboardEndPoint = 'https://coin-service-coin-user-dashboard-server-zatxacztoa-uc.a.run.app';
export default CoinCloudApiWrapper;
//# sourceMappingURL=Wrapper.js.map